import { FormActionFrameworkStep, registerStep } from '../step';
import { resolveTemplate } from '../template';
import { findSurveyQuestion, resolveFieldName } from './populateDropdown';
export class ClearFieldsStep extends FormActionFrameworkStep {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'clearFields'
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                fieldNames: '',
            }
        });
    }
    async execute(context) {
        const names = parseFieldNames(this.config, context);
        if (!names.length) {
            context.log('[clearFields] no fieldNames — skipped');
            return context;
        }
        const model = context.form;
        if (!model) {
            context.log('[clearFields] no form model on context — skipped');
            return context;
        }
        for (const fieldName of names) {
            clearField(model, fieldName, context);
        }
        context.formValues = {
            ...context.formValues,
            ...(model.data && typeof model.data === 'object' ? { ...model.data } : {}),
        };
        for (const fieldName of names) {
            context.formValues[fieldName] = null;
        }
        context.log(`[clearFields] cleared: ${names.join(', ')}`);
        return context;
    }
    showStepForm(container) {
        container.innerHTML = '';
    }
}
function parseFieldNames(config, context) {
    const raw = (typeof config.fieldNames === 'string' && config.fieldNames) ||
        (typeof config.fieldName === 'string' && config.fieldName) ||
        '';
    const resolved = resolveTemplate(raw, context);
    const text = resolved == null
        ? ''
        : typeof resolved === 'object'
            ? JSON.stringify(resolved)
            : String(resolved);
    return text
        .split(/[\n,;]+/)
        .map((s) => resolveFieldName({ fieldName: s.trim() }))
        .filter((s) => !!s);
}
function clearField(model, fieldName, context) {
    const question = findSurveyQuestion(model, fieldName);
    if (question) {
        question.value = null;
        return;
    }
    if (typeof model.clearValue === 'function') {
        model.clearValue(fieldName);
        return;
    }
    if (typeof model.setValue === 'function') {
        model.setValue(fieldName, null);
        return;
    }
    context.log(`[clearFields] question not found for "${fieldName}" — skipped`);
}
registerStep('clearFields', ClearFieldsStep);
